The information of the draft position required for the posting.
